module.exports = __webpack_public_path__ + "static/media/nike.266ebdb7.png";